import React, { useState ,useRef} from 'react';
import {
  AppBar, Toolbar, Typography, Container, CssBaseline, ThemeProvider,
  Paper, TextField, Button, CircularProgress, Box, Divider
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import Footer from '../pages/Footer';
import logo from '../logo.png';
import axios from 'axios';
import UserProfileEditor from './UserProfileEditor'; // 👈 New import
import { Alert } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
// ... your other imports

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: 'rgb(18,82,166)',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Times New Roman", Times, serif',
  },
});
export default function UpdatePreferencePage() {
    const [transactionNumber, setTransactionNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [student, setStudent] = useState(null);
    
    const recaptchaRef = useRef(null);

    const handleVerify = async () => {
        if (!transactionNumber) {
          setError('Transaction number is required.');
          return;
        }
      
        if (!recaptchaRef.current) {
          setError('Captcha is not ready. Please refresh the page.');
          return;
        }
      
        setLoading(true);
        setError('');
      
        try {
          let recaptchaToken = null;
      
           try {
            recaptchaToken = await recaptchaRef.current.executeAsync();
            recaptchaRef.current.reset();
          } catch (captchaError) {
            console.error('reCAPTCHA execution error:', captchaError);
            setError('Too many attempts or a browser issue. Please refresh and try again.');
            setLoading(false);
            return;
          }
      
          // ✅ If captcha succeeded, proceed to backend
          const res = await axios.post('https://exam.ethernet.edu.et/api/verify-transaction', {
            transaction_number: transactionNumber,
            recaptcha_token: recaptchaToken,
          });
      
          setStudent(res.data);
        } catch (err) {
          console.error('Server or network error:', err);
          setError(err.response?.data?.error || 'Verification failed. Please try again.');
        } finally {
          setLoading(false);
        }
      };
      
      

      
    
    return (
      <ThemeProvider theme={defaultTheme}>
        <div className="page-container">
          <CssBaseline />
          <AppBar position="static">
            <Toolbar>
              <img src={logo} alt="Ministry of Education Logo" style={{ maxHeight: '70px', marginRight: '20px' }} />
              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                Ministry of Education
              </Typography>
            </Toolbar>
          </AppBar>
  
          <Container component="main" sx={{ maxWidth: 'sm', py: 6, minHeight: '80vh' }}>
            {!student ? (
              <Paper elevation={3} sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
                <Typography variant="h6" gutterBottom>
                  🔐 Access Your Profile
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography
                  sx={{
                    mb: 1,
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: '#444',
                    lineHeight: 1.7,
                  }}
                >
                  Please enter your <strong>payment transaction number</strong> received from <strong>TeleBirr</strong> during payment to manage your profile and access your exam credentials.
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.95rem',
                    color: '#1976d2',
                    fontWeight: 500,
                    mt: 1,
                  }}
                >
                  Need help?{' '}
                  <a
                    href="https://youtu.be/C9KkQ9AHd2o"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: 'underline',
                      color: '#1976d2',
                      fontWeight: 500,
                    }}
                  >
                    Watch this video guide
                  </a>
                </Typography>
                <br />
                <TextField
                  fullWidth
                  label="Transaction Number"
                  value={transactionNumber}
                  onChange={(e) => setTransactionNumber(e.target.value)}
                  sx={{ mb: 2 }}
                />
                {error && (
                  <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
                )}
 

                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                  <Button variant="contained" href="/register">Back</Button>
                  <Button
                    variant="contained"
                    onClick={handleVerify}
                    disabled={!transactionNumber || loading}
                  >
                    {loading ? <CircularProgress size={24} /> : 'Verify and Continue'}
                  </Button>
                </Box>
              </Paper>
            ) : (
                 <UserProfileEditor student={student} recaptchaRef={recaptchaRef} />
            )}
          </Container>
  
          <Footer />
  
          {/* The Invisible reCAPTCHA component */}
          <ReCAPTCHA
            sitekey="6LepLRQrAAAAAGsabsOe4cjcNnm61WG8fuFvuIUq"   
            size="invisible"
            ref={recaptchaRef}
          />
        </div>
      </ThemeProvider>
    );
  }
  